// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__12FQC","footer":"ModalUpdate_footer__-N8HD"};